export enum Level {
  ERROR = 'ERROR',
  INFO = 'INFO',
  SUCCESS = 'SUCCESS'
}

export enum ItemType {
  CONTRACT = 'CONTRACT',
  ENTITY = 'ENTITY'
}

export enum EventType {
  FUNCTIONAL = 'FUNCTIONAL',
  TECHNICAL = 'TECHNICAL'
}

export enum Status {
  RESOLVED_IGNORED = 'RESOLVED_IGNORED'
}

export interface StatusMetadata {
  actualStatus?: Status;
  comment?: string;
  updateDate: string;
  lastUpdateAuthor: string;
}

export interface LogEvent {
  id: number;
  createDate: string;
  level: Level;
  itemType: ItemType;
  eventType: EventType;
  category: string;
  message: string;
  status?: Status;
  last: boolean;
  itemId: number;
  cliCoreId?: number;
  statusMetadata?: StatusMetadata;
}

export interface UpdateLogEvent {
  status: Status;
  comment?: string;
}
